import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    question: "Who is this course designed for?",
    answer: "This course is specifically designed for experienced Oracle DBAs who want to transition to Oracle Cloud Infrastructure (OCI). Whether you're managing on-premise databases and want to move to the cloud, or you want to become a certified OCI Architect, this course is for you."
  },
  {
    question: "What are the prerequisites?",
    answer: "Basic knowledge of Oracle Database Administration is recommended. You should be familiar with Oracle database concepts, SQL, and general IT infrastructure. No prior cloud experience is required — we'll build that foundation together."
  },
  {
    question: "What is the course schedule?",
    answer: "We offer three courses: 1) AWS Cloud Infrastructure — 65 Hrs, 8 modules, starts 15-Jun-2026, Mon-Thu 5:00-6:15 PM IST. 2) AWS Cloud & Database Architect (Combined) — 100 Hrs, 21 modules + capstone, Sat 8:30-10:30 AM IST, first class 11-Jul, ongoing. 3) Complete OCI Mastery — 60-65 Hrs, 10 modules, free demo 30-May-2026, starts 03-Jun-2026, Mon-Thu 8:30-10:00 AM IST."
  },
  {
    question: "How are classes conducted?",
    answer: "All classes are conducted live via Zoom with interactive Q&A sessions. You'll receive the Zoom meeting link and password after enrollment. Recordings will be available for review."
  },
  {
    question: "What topics are covered in the syllabus?",
    answer: "AWS Cloud Infrastructure covers 8 modules (AWS Global Infra, EC2, Storage, VPC, Security, Backup & DR, Observability, Migration). AWS Cloud & Database Architect (Combined) has 21 modules in two parts: Part A — Solutions Architect Associate (9 modules, 40 Hrs) and Part B — Database Architect (12 modules, 60 Hrs) + capstone project. OCI Mastery covers 10 modules (Networking, Compute, Storage, OCI Database Service, Terraform, Ansible, Multicloud, IAM, Kubernetes & Docker, Enterprise/Database Migration)."
  },
  {
    question: "How can I enroll or get more information?",
    answer: "You can enroll by filling the form on this page, or contact us directly at +91-8978266997. You can also join our WhatsApp group for updates and discussions."
  },
  {
    question: "Is there any hands-on practice included?",
    answer: "Absolutely! Each module includes practical labs using Oracle Cloud Free Tier accounts. You'll get hands-on experience with real OCI services, Terraform deployments, and Ansible automation."
  },
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#111118]">
      <div className="max-w-3xl mx-auto">
        <div className="mb-12 text-center">
          <p className="font-mono text-xs text-[#22D3EE] uppercase tracking-widest mb-2">// questions</p>
          <h2 className="font-['Space_Grotesk'] text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-[#F4F4F5]">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-base text-[#A1A1AA]">
            Everything you need to know about the course.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              data-testid={`faq-accordion-item-${index}`}
              className="border-b border-[#27272A]"
            >
              <AccordionTrigger className="text-left font-['Space_Grotesk'] font-semibold text-[#F4F4F5] hover:text-[#22D3EE] hover:no-underline py-5 text-sm">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#A1A1AA] leading-relaxed pb-5 text-sm">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
